import { useLoaderData } from "react-router-dom";
import SuspenseVideoPlayer from "../../components/SuspenseVideoPlayer";
import { Capsule } from "../../services/capsule/capsuleModel";

const CapsuleEmbedPage = () => {
  const { capsule, video } = useLoaderData() as {
    capsule: Capsule;
    video: Promise<Blob>;
  };

  return (
    <div className="video-container --embed">
      <SuspenseVideoPlayer videoPromise={video} thumbnail={capsule.thumbnail} />
    </div>
  );
};

export default CapsuleEmbedPage;
